import actionsLocale from '../components/RowActions/defaultStrings_en_US';
import controlBarLocale from '../components/ControlBar/defaultStrings_en_US';
import gridLocale from '../components/Grid/defaultStrings_en_US';
import subRowControlLocale from '../components/SubRowControl/defaultStrings_en_US';
import headerCellLocale from '../components/HeaderCell/defaultStrings_en_US';
import composedGridLocale from '../components/ComposedGrid/defaultStrings_en_US';

export default {
  gridReact: {
    ...actionsLocale,
    ...controlBarLocale,
    ...gridLocale,
    ...subRowControlLocale,
    ...headerCellLocale,
    ...composedGridLocale
  }
};
